import { FunctionComponent, useEffect, useState } from "react";
import "./VirtualClassLandingPage.scss";
import { useNavigate } from "react-router-dom";
import images from "../../assets/images";
import { useDispatch } from "react-redux";
import { logout } from "../../redux/slices/authSlice";
import { useQuery } from "@apollo/client";
import { LOGIN_SCREEN_DETAILS } from "./api/VirtualClassLandingPage";
import ToasterWithMessage from "../../components/toaster";
import Loader from "../../components/Loader/Loader";
import { VIRTUAL_S3_PATH } from "../../utils/constants";

type loginDetails = {
  ldId: string;
  avatarUrl: string;
  colorCode: string;
  role: string;
}

const VirtualClassLandingPage: FunctionComponent = () => {
  const navigate = useNavigate();
  const { GreenCircleWithChecked, KatonLogoBlue } = images;
  const [selected, setSelected] = useState<number | undefined>();
  const dispatch = useDispatch();
  const { error } = ToasterWithMessage();
  const baseUrl = process.env.REACT_APP_FRONTEND_URL;
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    dispatch(logout());

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const { data, loading } = useQuery(LOGIN_SCREEN_DETAILS, {
    fetchPolicy: "network-only",
    onError: (err) => {
      error(err?.message);
    }
  })

  const handleSelected = async (index: number) => {
    if (index === selected) {
      setSelected(undefined);
    }
    else {
      setSelected(index);
    }
  }  

  const handleClick = () => {    
    if (selected !== undefined) {
      const component = selected === 0 ? '/virtual-school/virtual-student-signup?isKaton=virtualSchool' : '/virtual-school/virtual-teacher-login?isKaton=virtualSchool';
      navigate(component);
    }
  }
  
  return (
    <>
      {(!loading) ? (
        <section className="VirtualClassMainContainer">
        <div className="VirtualLandingPagecontainer">
          <div className="contentContainer">
          {windowWidth <= 768 && <img src={KatonLogoBlue} alt="katonlogo" className="katonLogo" />}
            <div className="appName">360 CLASSROOM</div>
            <div className="contentMain">{'TEACH SMART, LEARN EASY.'}</div>
            <div className="contentSub">{'Welcome to the Katon 360 Classroom where Teachers, Students and Parents meet to continue the traditional classroom activities.'}</div>
          </div>
          <div className="cardMainContainer">
            { data?.allLoginScreenDetails?.nodes?.map((val: loginDetails, index: number) => {
              return (
                <div className="cardOuterContainer" onClick={() => handleSelected(index)}>
                  <div className="cardContainer" style={{ backgroundColor: val?.colorCode }} >
                    <div className="cardContentContainer">
                    <img src={baseUrl + VIRTUAL_S3_PATH + val?.avatarUrl} alt="avatarImage" className="cardImage" />
                    <div className="userContainer">
                        {windowWidth > 768 ? (
                          <>
                            <div>Join</div>
                            <div>{`as a ${val?.role}`}</div>
                          </>
                        ) : (
                          <div>{val?.role}</div>
                        )}
                    </div>
                    </div>
                    {(index === selected && windowWidth <= 768 ) && <img src={GreenCircleWithChecked} alt="checkedIcon" className="selectedIcon" />}
                  </div>
                  {(index === selected && windowWidth > 768 ) && <img src={GreenCircleWithChecked} alt="checkedIcon" className="selectedIcon" />}
                  {selected === undefined && windowWidth > 768 && <div className="selectedIcon" />}
                </div>
              )
            }) 
            }
          </div>
        </div>
        <div className="buttonContainer">
        <button className={`proceedBtn ${selected === undefined ? "disableBtn" : ""}`} onClick={handleClick}>Proceed</button>
      </div>
    </section>
      ) : 
      <section className="VirtualClassMainContainer">
      <Loader />
      </section>}
      </>
  )
};

export default VirtualClassLandingPage;